module.exports = __webpack_public_path__ + "img/emoji_62.486dc497.png";